import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// TODO: aggiorna path al tuo DTO reale
import { LoadingListItems } from '../interfaces/LoadingListItems.interfaces';

@Injectable({ providedIn: 'root' })
export class LoadingListItemsService {

  private readonly baseUrl = `${environment.apiUrl}/opr/loading-list-items`;

  constructor(private http: HttpClient) {}

  getByLoadingListId(loadingListId: number): Observable<LoadingListItems[]> {
    // esempio: GET /opr/loading-list-items/by-loading-list/123
    return this.http.get<LoadingListItems[]>(`${this.baseUrl}/by-loading-list/${loadingListId}`);
  }

  printSingleLoadingList(loadingListId: number): Observable<Blob> {
    // esempio: POST /opr/loading-list-items/print { loadingListId: 123 }
    return this.http.post(`${this.baseUrl}/print`, { loadingListId }, { responseType: 'blob' });
  }

  exportSingleLoadingList(loadingListId: number): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/export`, { loadingListId }, { responseType: 'blob' });
  }
}
